import { render, staticRenderFns } from "./guilds.vue?vue&type=template&id=cac133f2&scoped=true&"
import script from "./guilds.vue?vue&type=script&lang=js&"
export * from "./guilds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac133f2",
  null
  
)

export default component.exports